/* General API Constant */
export const API_BASE_URL =
  process.env.REACT_APP_CONTAINER_1_URL || 'https://zjrtgqp4r8.execute-api.us-east-1.amazonaws.com/prod';



